import { Component, ContentChild, ContentChildren, EventEmitter, Input, OnInit, Output, QueryList, TemplateRef, ViewChild } from '@angular/core';
import { BadgeKind, MenuButtonMode, MenuXPosition } from '@sb/library/base';
import { ButtonBaseComponent } from '../button-base.component';
import { ButtonComponent } from '../button.component';
import { MenuItemComponent } from './menu-item/menu-item.component';

@Component({
    selector: 'lib-menu-button',
    templateUrl: './menu-button.component.html',
    styleUrls: ['./menu-button.component.scss']
})
export class MenuButtonComponent extends ButtonBaseComponent implements OnInit {
    private _subMenuItems!: QueryList<MenuItemComponent>;

    @ContentChild('menuContent', { static: false })
    menuContent!: TemplateRef<any>;

    @ContentChild('buttonContentTemplate', { static: false })
    buttonContentTemplate!: TemplateRef<any>;

    @ContentChildren(MenuItemComponent) menuItemComponents!: QueryList<MenuItemComponent>;

    @ViewChild('baseButton', { static: false }) baseButtonRef!: ButtonComponent;

    private _hasCaretSuffix: boolean = true;
    @Input()
    set hasCaretSuffix(value: boolean) {
        this._hasCaretSuffix = value;
        this.suffixIcon = value ? this.Icon.Common.CaretDown : this.suffixIcon;
    }
    @Input() mode: MenuButtonMode = MenuButtonMode.Default;
    @Input() customClass: string = '';
    @Input() xPosition: MenuXPosition = 'after';
    @Input() badgeKind: BadgeKind | null = null; // badgeKind compatible with ButtonMode IconOnly

    @Output() override menuClosed: EventEmitter<void> = new EventEmitter();

    override ngOnInit(): void {
        super.ngOnInit();
        if (this.hasCaretSuffix) {
            this.suffixIcon = this.Icon.Common.CaretDown;
        }
    }

    OpenMenu(event?: MouseEvent) {
        this.clicked.emit();
        if (event && this.stopPropagation) {
            event.stopPropagation();
        }
        if (this.baseButtonRef.menuTriggerRef?.menuOpened && this.suffixIcon === this.Icon.Common.CaretDown) {
            this.suffixIcon = this.Icon.Common.CaretUp;
        }
    }

    OpenMenuFromEnter(): void {
        this.baseButtonRef.menuTriggerRef.openMenu();
        this.OpenMenu();
    }

    OpenMenuItem(menuItem: MenuItemComponent) {
        this._subMenuItems = menuItem.subMenuItems;
    }

    CloseMenu() {
        if (!this.disabled) {
            this.baseButtonRef.menuTriggerRef.closeMenu();
        }
    }

    MenuItemClicked(item: MenuItemComponent, event: MouseEvent) {
        if (!item.disabled) {
            item.clicked.emit();
        }

        if (item.stopPropagation) {
            event.stopPropagation();
        }
    }

    override MenuClosed(): void {
        this.menuClosed.emit();
        if (this.suffixIcon === this.Icon.Common.CaretUp) {
            this.suffixIcon = this.Icon.Common.CaretDown;
        }
    }

    get subMenuItems(): QueryList<MenuItemComponent> {
        return this._subMenuItems;
    }

    get menuOpened(): boolean {
        return this.baseButtonRef.menuTriggerRef ? this.baseButtonRef.menuTriggerRef!.menuOpen : false;
    }

    get hasCaretSuffix(): boolean {
        return this._hasCaretSuffix;
    }
}
